module.exports = __webpack_public_path__ + "static/logo-blockchain@2x-9a87395ee993427fb02841bc26fefd19.png";